import Vue from 'vue'
// eslint-disable-next-line
import _ from 'lodash';
import ajax from '../api/index';


export default {
	handleExportExcel(option) { //导出
		const message = Vue.prototype.$message;
		return new Promise(resolve => {
			ajax.post('export/add', option, res => {
				if (res.code == 0) {
					message.success(res.msg);
				} else {
					message.error(res.msg);
				}
				resolve(res);
			})
		});
	},
	objectToQuery() {
		let obj = arguments[0];
		let prefix = arguments[1];
		if (typeof obj !== "object") return "";
		const attrs = Object.keys(obj);
		return attrs.reduce((query, attr, index) => {
			if (index === 0 && !prefix) query += "?";
			if (typeof obj[attr] === "object") {
			  const subPrefix = prefix ? `${prefix}[${attr}]` : attr;
			  query += this.objectToQuery(obj[attr], subPrefix);
			} else {
			  if (prefix) {
				  query += `${prefix}[${attr}]=${obj[attr]}`;
			  } else {
				  query += `${attr}=${obj[attr]}`;
			  }
			}
			if (index !== attrs.length - 1) query += "&";
			return query;
		}, "");
	}
}